module.exports = __webpack_public_path__ + "static/img/company-ethics-hero.aa87b34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/company-ethics-hero.jpg
// module id = Ju6z
// module chunks = 0